// @ts-nocheck
import * as Types from '../../../generated/graphqlTypes';

import { gql } from '@apollo/client';
import { AssetInfoFragmentDoc } from '../../projects/assets/AssetPreview.generated';
import { DisplayNamedFragmentDoc, NamedFragmentDoc } from '../../../fragments/commonFragments.generated';
import * as Apollo from '@apollo/client';
import * as ApolloReactHooks from 'src/apolloHooks';
const defaultOptions = {} as const;
export type FinishScheduleVisualModePdfQueryVariables = Types.Exact<{
  filter: Types.DesignPackageFinishScheduleFilter;
  versionId: Types.Scalars['ID']['input'];
  designPackageId: Types.Scalars['ID']['input'];
}>;


export type FinishScheduleVisualModePdfQuery = { __typename?: 'Query', designPackage: { __typename?: 'DesignPackage', id: string, combinations: Array<{ __typename?: 'DesignPackageOptionCombination', id: string, name: string, options: Array<{ __typename?: 'ReadyPlanOption', id: string, order: number, name: string }> }> }, readyPlanAggregateVersion: { __typename?: 'ReadyPlanAggregateVersion', id: string, version?: number | null | undefined }, designPackageFinishSchedule: { __typename?: 'DesignPackageFinishSchedulePageResult', entities: Array<{ __typename?: 'TakeoffLineItem', id: string, name: string, location: { __typename?: 'Location', id: string, name: string, type: { __typename?: 'LocationTypeDetail', code: Types.LocationType }, room?: { __typename?: 'Location', id: string, name: string } | null | undefined }, item: { __typename?: 'Item', id: string, name: string }, options: Array<{ __typename?: 'ReadyPlanOption', id: string, name: string, order: number, optionGroup: { __typename?: 'ReadyPlanOptionGroup', id: string, name: string, forDesignUpgrade: boolean, forDesignPackages: boolean, order: number, group: { __typename?: 'GlobalOptionGroup', id: string, name: string, type: { __typename?: 'GlobalOptionType', id: string, name: string } } } }>, materialVariant?: { __typename?: 'MaterialVariant', id: string, manufacturerUrl?: string | null | undefined, blueprintUrl: { __typename?: 'Url', url: string }, featuredImage?: { __typename?: 'MaterialVariantImage', id: string, asset?: { __typename?: 'Asset', id: string, version: string, contentType: string, downloadUrl: string, attachmentUrl: string, fileName?: string | null | undefined, createdAt: Types.Scalars['DateTime']['input'], previewUrl?: string | null | undefined } | null | undefined } | null | undefined, listing: { __typename?: 'MaterialListing', id: string, name?: string | null | undefined, brand?: { __typename?: 'MaterialBrand', id: string, name: string } | null | undefined }, materialAttributeValues: Array<{ __typename?: 'MaterialAttributeValue', id: string, textValue: string, dimension: { __typename?: 'MaterialAttributeDimension', id: string, name: string, useInVisualModePdf: boolean, type: { __typename?: 'MaterialAttributeDimensionTypeDetail', code: Types.MaterialAttributeDimensionType }, unitOfMeasure?: { __typename?: 'UnitOfMeasure', id: string, abbreviation: string } | null | undefined } }> } | null | undefined, targetCombinations: Array<{ __typename?: 'DesignPackageOptionCombination', id: string, options: Array<{ __typename?: 'ReadyPlanOption', id: string }> }> }> }, locations: Array<{ __typename?: 'Location', id: string, name: string, type: { __typename?: 'LocationTypeDetail', code: Types.LocationType }, room?: { __typename?: 'Location', id: string, name: string } | null | undefined }> };

export type FinishScheduleVisualMode_TliFragment = { __typename?: 'TakeoffLineItem', id: string, name: string, location: { __typename?: 'Location', id: string, name: string, type: { __typename?: 'LocationTypeDetail', code: Types.LocationType }, room?: { __typename?: 'Location', id: string, name: string } | null | undefined }, item: { __typename?: 'Item', id: string, name: string }, options: Array<{ __typename?: 'ReadyPlanOption', id: string, name: string, order: number, optionGroup: { __typename?: 'ReadyPlanOptionGroup', id: string, name: string, forDesignUpgrade: boolean, forDesignPackages: boolean, order: number, group: { __typename?: 'GlobalOptionGroup', id: string, name: string, type: { __typename?: 'GlobalOptionType', id: string, name: string } } } }>, materialVariant?: { __typename?: 'MaterialVariant', id: string, manufacturerUrl?: string | null | undefined, blueprintUrl: { __typename?: 'Url', url: string }, featuredImage?: { __typename?: 'MaterialVariantImage', id: string, asset?: { __typename?: 'Asset', id: string, version: string, contentType: string, downloadUrl: string, attachmentUrl: string, fileName?: string | null | undefined, createdAt: Types.Scalars['DateTime']['input'], previewUrl?: string | null | undefined } | null | undefined } | null | undefined, listing: { __typename?: 'MaterialListing', id: string, name?: string | null | undefined, brand?: { __typename?: 'MaterialBrand', id: string, name: string } | null | undefined }, materialAttributeValues: Array<{ __typename?: 'MaterialAttributeValue', id: string, textValue: string, dimension: { __typename?: 'MaterialAttributeDimension', id: string, name: string, useInVisualModePdf: boolean, type: { __typename?: 'MaterialAttributeDimensionTypeDetail', code: Types.MaterialAttributeDimensionType }, unitOfMeasure?: { __typename?: 'UnitOfMeasure', id: string, abbreviation: string } | null | undefined } }> } | null | undefined, targetCombinations: Array<{ __typename?: 'DesignPackageOptionCombination', id: string, options: Array<{ __typename?: 'ReadyPlanOption', id: string }> }> };

export type FinishScheduleVisualMode_ReadyPlanOptionFragment = { __typename?: 'ReadyPlanOption', id: string, name: string, order: number, optionGroup: { __typename?: 'ReadyPlanOptionGroup', id: string, name: string, forDesignUpgrade: boolean, forDesignPackages: boolean, order: number, group: { __typename?: 'GlobalOptionGroup', id: string, name: string, type: { __typename?: 'GlobalOptionType', id: string, name: string } } } };

export type FinishScheduleVisualMode_MaterialAttributeValueFragment = { __typename?: 'MaterialAttributeValue', id: string, textValue: string, dimension: { __typename?: 'MaterialAttributeDimension', id: string, name: string, useInVisualModePdf: boolean, type: { __typename?: 'MaterialAttributeDimensionTypeDetail', code: Types.MaterialAttributeDimensionType }, unitOfMeasure?: { __typename?: 'UnitOfMeasure', id: string, abbreviation: string } | null | undefined } };

export type FinishScheduleVisualMode_LocationFragment = { __typename?: 'Location', id: string, name: string, type: { __typename?: 'LocationTypeDetail', code: Types.LocationType }, room?: { __typename?: 'Location', id: string, name: string } | null | undefined };

export const FinishScheduleVisualMode_LocationFragmentDoc = gql`
    fragment FinishScheduleVisualMode_Location on Location {
  ...Named
  type {
    code
  }
  room {
    ...Named
  }
}
    ${NamedFragmentDoc}`;
export const FinishScheduleVisualMode_ReadyPlanOptionFragmentDoc = gql`
    fragment FinishScheduleVisualMode_ReadyPlanOption on ReadyPlanOption {
  id
  name
  order
  optionGroup {
    id
    name
    forDesignUpgrade
    forDesignPackages
    order
    group {
      id
      name
      type {
        id
        name
      }
    }
  }
}
    `;
export const FinishScheduleVisualMode_MaterialAttributeValueFragmentDoc = gql`
    fragment FinishScheduleVisualMode_MaterialAttributeValue on MaterialAttributeValue {
  id
  textValue
  dimension {
    id
    name
    useInVisualModePdf
    type {
      code
    }
    unitOfMeasure {
      id
      abbreviation
    }
  }
}
    `;
export const FinishScheduleVisualMode_TliFragmentDoc = gql`
    fragment FinishScheduleVisualMode_Tli on TakeoffLineItem {
  id
  location {
    ...FinishScheduleVisualMode_Location
  }
  id
  item {
    id
    name
  }
  options {
    ...FinishScheduleVisualMode_ReadyPlanOption
  }
  name
  materialVariant {
    id
    manufacturerUrl
    blueprintUrl {
      url
    }
    featuredImage {
      id
      asset {
        ...AssetInfo
      }
    }
    listing {
      id
      name
      brand {
        id
        name
      }
    }
    materialAttributeValues {
      ...FinishScheduleVisualMode_MaterialAttributeValue
    }
  }
  targetCombinations {
    id
    options {
      id
    }
  }
}
    ${FinishScheduleVisualMode_LocationFragmentDoc}
${FinishScheduleVisualMode_ReadyPlanOptionFragmentDoc}
${AssetInfoFragmentDoc}
${FinishScheduleVisualMode_MaterialAttributeValueFragmentDoc}`;
export const FinishScheduleVisualModePdfDocument = gql`
    query FinishScheduleVisualModePdf($filter: DesignPackageFinishScheduleFilter!, $versionId: ID!, $designPackageId: ID!) {
  designPackage(id: $designPackageId, versionId: $versionId) {
    id
    combinations {
      id
      name
      options {
        id
        order
        name
      }
    }
  }
  readyPlanAggregateVersion(id: $versionId) {
    id
    version
  }
  designPackageFinishSchedule(filter: $filter) {
    entities {
      ...FinishScheduleVisualMode_Tli
    }
  }
  locations(filter: {version: [2]}) {
    ...FinishScheduleVisualMode_Location
  }
}
    ${FinishScheduleVisualMode_TliFragmentDoc}
${FinishScheduleVisualMode_LocationFragmentDoc}`;

/**
 * __useFinishScheduleVisualModePdfQuery__
 *
 * To run a query within a React component, call `useFinishScheduleVisualModePdfQuery` and pass it any options that fit your needs.
 * When your component renders, `useFinishScheduleVisualModePdfQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFinishScheduleVisualModePdfQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      versionId: // value for 'versionId'
 *      designPackageId: // value for 'designPackageId'
 *   },
 * });
 */
export function useFinishScheduleVisualModePdfQuery(baseOptions: ApolloReactHooks.QueryHookOptions<FinishScheduleVisualModePdfQuery, FinishScheduleVisualModePdfQueryVariables> & ({ variables: FinishScheduleVisualModePdfQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<FinishScheduleVisualModePdfQuery, FinishScheduleVisualModePdfQueryVariables>(FinishScheduleVisualModePdfDocument, options);
      }
export function useFinishScheduleVisualModePdfLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<FinishScheduleVisualModePdfQuery, FinishScheduleVisualModePdfQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<FinishScheduleVisualModePdfQuery, FinishScheduleVisualModePdfQueryVariables>(FinishScheduleVisualModePdfDocument, options);
        }
// @ts-ignore
export function useFinishScheduleVisualModePdfSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<FinishScheduleVisualModePdfQuery, FinishScheduleVisualModePdfQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<FinishScheduleVisualModePdfQuery, FinishScheduleVisualModePdfQueryVariables>;
export function useFinishScheduleVisualModePdfSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<FinishScheduleVisualModePdfQuery, FinishScheduleVisualModePdfQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<FinishScheduleVisualModePdfQuery | undefined, FinishScheduleVisualModePdfQueryVariables>;
export function useFinishScheduleVisualModePdfSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<FinishScheduleVisualModePdfQuery, FinishScheduleVisualModePdfQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<FinishScheduleVisualModePdfQuery, FinishScheduleVisualModePdfQueryVariables>(FinishScheduleVisualModePdfDocument, options);
        }
export type FinishScheduleVisualModePdfQueryHookResult = ReturnType<typeof useFinishScheduleVisualModePdfQuery>;
export type FinishScheduleVisualModePdfLazyQueryHookResult = ReturnType<typeof useFinishScheduleVisualModePdfLazyQuery>;
export type FinishScheduleVisualModePdfSuspenseQueryHookResult = ReturnType<typeof useFinishScheduleVisualModePdfSuspenseQuery>;
export type FinishScheduleVisualModePdfQueryResult = Apollo.QueryResult<FinishScheduleVisualModePdfQuery, FinishScheduleVisualModePdfQueryVariables>;